<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header"><h5>СДЕК</h5></div>
      <div class="card-body">
        <div class="form-group">
          <label for="">Поиск препарата</label>
          <input placeholder="Введите название для поиска" @input="filterDrugs()" type="text" @keyup="filterDrugs"
                 class="form-control"
                 v-model="searchDrugText">
        </div>
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div class="alert alert-danger" v-if="Object.keys(missExpDatesRecords).length">
          <p>Не указаны сроки годности на <strong>{{ Object.keys(missExpDatesRecords).length }}</strong> препаратах</p>
          <p>Данные <strong>НЕ</strong> будут приняты без актуальных сроков годности</p>
        </div>
        <div class="mt-1 flex justify-content-between">
          <div class="flex flex_gap_5">
            <button @click="filterDrugs('title')" tabindex="-1" type="button"
                    :class="{'btn btn-default btn-outline-dark':true, 'active': sortDirection === 'title'}">Сортировка
              по алфавиту
            </button>
            <button @click="filterDrugs('updated')" tabindex="-1" type="button"
                    :class="{'btn btn-default btn-outline-dark':true, 'active': sortDirection === 'updated'}">Сортировка
              по добавлению
            </button>
          </div>
          <div class="flex flex_gap_5 justify-content-end">
            <button type="button" @click="showFilledRecords" tabindex="-1" class="btn btn-outline-info">Показать
              {{ showFilled ? 'все' : 'заполненые' }}
            </button>
            <LoadingButton
              title="Закончить приемку"
              type="button"
              :loading="btnLoading"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => closeIncome()"
              className="btn btn-outline-success"
            />
          </div>
        </div>
        <table class="table table-sm table-hover mt-1" v-if="!loading">
          <thead>
          <tr>
            <th></th>
            <th></th>
            <th>Препарат</th>
            <th>Комплектность</th>
            <th>На складе</th>
            <th>Ревизия</th>
            <th>Срок годности</th>
          </tr>
          </thead>
          <tbody>
          <!--              v-if="(showFilled && +revisionRecords[r.drug_id].revisionQty) || (!showFilled && ((hasErrors && hasNoSelectedDate(r.drug_id)) || !hasErrors))"-->
          <!--              v-if="(showFilled && revisionRecords[r.drug_id].revisionQty) || !showFilled"-->
          <!--          <tr v-for="(r, i) in filteredRecords" :key="r.drug_id"-->
          <tr v-for="(r, i) in getSortedRecords()" :key="r.drug_id"
              :class="{bg_danger: hasNoSelectedDate(r.drug_id)}">
            <td>{{ i + 1 }}</td>
            <td>
              <i class="icon-fa icon-fa-photo pointer" v-if="drugsImages[r.drug.id]"
                 @click="updateImageTooltip(true, r.drug.id)"></i>
              <v-popover
                v-if="openImageTooltip[r.drug.id]"
                class="d-inline"
                placement="bottom"
                :open="openImageTooltip[r.drug.id]"
                @hide="() => updateImageTooltip(false, r.drug.id)"
                :auto-hide="true"
              >
                <!--                <i class="icon-fa icon-fa-photo pointer"></i>-->
                <template slot="popover">
                  <img tabindex="-1" :src="drugsImages[r.drug.id]" alt="">
                </template>
              </v-popover>
            </td>
            <td>
              <p>{{ r.drug.title }}</p>
              <p>{{ r.drug.en_title }}</p>
              <p>{{ r.updated_timestamp }}</p>
              <p class="text-muted" v-if="r.drug.pack_comment">{{ r.drug.pack_comment }}</p>
              <p class="text-muted" v-if="r.drug.pack_box_comment">{{ r.drug.pack_box_comment }}</p>
              <p v-if="r.drug.cool"><i class="icon icon-snowflake pull-left mr-2"/> Требуется хладоген</p>
            </td>
            <td>
              <span class="badge badge-info" v-if="+r.drug.pack_set !== 1">1 комплект ({{
                  +r.drug.pack_set
                }} зав.уп.)</span>
            </td>
            <td>
              <input type="text" tabindex="-1" disabled v-model="r.qty" class="form-control">
            </td>
            <td>
              <input type="number" @change="updateRecord(r.drug_id, 'qty')"
                     v-model="revisionRecords[r.drug_id].revisionQty"
                     class="form-control">
            </td>
            <td>
              <template v-if="+revisionRecords[r.drug_id].revisionQty && +revisionRecords[r.drug_id].showExpDates">

                <ExpireDatesByMask
                  ref="expDatesSelect"
                  v-if="revisionRecords[r.drug_id].extra_data"
                  :allToSelectDate="true"
                  :disableEdit="true"
                  :updateDates="(d) => updateRecordDates(d, r.drug_id)"
                  :revisionId="currentRevision.id"
                  :drugId="r.drug_id"
                  :savedDates="revisionRecords[r.drug_id].extra_data.expire_dates"
                  :expireDates="revisionRecords[r.drug_id].expireDates"/>
              </template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>

import api from "@/api";
import moment from "moment";
import ExpireDatesByMask from "@/components/drugs/ExpireDatesByMask.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";

export default {
  components: {LoadingButton, ExpireDatesByMask},
  data() {
    return {
      sortDirection: 'title',
      showFilled: false,
      hasErrors: false,
      currentRevision: null,
      expireMask: [/[0-1]/, '#.', /[2-2]/, /[0-0]/, '##'],
      loading: false,
      btnLoading: false,
      missExpDatesRecords: {},
      storeRecords: null,
      filteredRecords: null,
      searchDrugText: null,
      revisionRecords: {},
      drugsImages: {},
      openImageTooltip: {},
    }
  },
  created() {
    this.getRecords();
  },
  watch: {
    'storeDrugData': {
      handler: function (val, oldVal) {
        console.log('filter');
        this.filterDrugs();
      },
    },
  },
  methods: {
    updateRecordDates(dates, id) {
      this.revisionRecords[id].extra_data.expire_dates = dates;
      this.revisionRecords[id].updated_timestamp = moment().utc().unix();
      this.getEmptyExpireDates();
    },
    showFilledRecords() {
      this.showFilled = !this.showFilled;
      this.searchDrugText = null;
      this.filterDrugs();
    },
    getSortedRecords() {
      const pull = _.orderBy(this.filteredRecords, this.sortDirection === 'title' ? 'drug.title' : 'updated_timestamp', this.sortDirection === 'updated' ? 'desc' : 'asc');
      if (this.showFilled) return pull.filter((r) => !!this.revisionRecords[r.drug_id].revisionQty)
      return pull;
    },
    showInList(record) {
      if (!this.showFilled) return true;
      return !!this.revisionRecords[record.drug_id].revisionQty;
    },
    async closeIncome() {
      const records = Object.values(this.revisionRecords).filter((r) => +r.revisionQty);
      if (!records.length) {
        toastr['warning']('Нет препаратов для проводки', 'Ошибка!');
        return;
      }
      this.getEmptyExpireDates();
      if (Object.keys(this.missExpDatesRecords).length) {
        toastr['warning']('Не заполнены сроки годности!', 'Ошибка!');
        return;
      }

      this.btnLoading = true;
      const {data} = await api.post('/invoices/updateByAction', {
        action: 'passSDEK',
        revision_id: this.currentRevision.id
      });
      if (data.success) {
        toastr['success']('Проведено', 'Успешно');
      } else {
        toastr['warning'](data.message ?? 'нет ответа', 'Ошибка');
      }
      this.btnLoading = false;
    },
    getEmptyExpireDates() {
      let missExpDates = Object.values(this.revisionRecords).filter((r) => +r.revisionQty && !(r.extra_data?.expire_dates ?? []).length);
      const selected = (this.$refs.expDatesSelect ?? []).reduce((acc, r) => {
        const s = Object.keys(r.selectedDates ?? {}).filter((k) => r.selectedDates[k]);
        if (s.length) {
          acc[r.drugId] = s;
        }
        return acc;
      }, {})
      // console.log(missExpDates);
      // console.log(selected);
      missExpDates = missExpDates.filter((r) => r?.drug?.id && !selected[r.drug.id]);
      // console.log(missExpDates);
      this.missExpDatesRecords = missExpDates.reduce((acc, r) => {
        acc[r.drug.id] = r;
        return acc;
      }, {});
      // return missExpDates.length;
    },
    updateImageTooltip(open, id) {
      if (open) {
        this.$set(this.openImageTooltip, id, true);
      } else {
        this.openImageTooltip[id] = false;
      }
      // console.log(open, id);
    },
    hasNoSelectedDate(drugId) {
      if (!+this.revisionRecords[drugId].revisionQty) return true;
      if (this.missExpDatesRecords[drugId]) return true;
      if (+this.revisionRecords[drugId].revisionQty !== +this.revisionRecords[drugId].qty) return true;
      return false;

      const dates = this.revisionRecords[drugId].expireDates.filter((d) => d.date);
      const comp = (this.$refs.expDatesSelect ?? []).find((c) => +c.drugId === +drugId);
      if (+drugId === 7771222) console.log(dates, comp);
      if (!comp) return true;
      if (Object.values(comp?.savedDates ?? {}).find((v) => v)) return false;
      return true;
      // if (!dates.length) return false;
      // return !dates.filter((d) => d.selected).length
    },
    async toggleSelectedDate(drugId, index = null, silent = false) {
      if (index !== null) {
        if (!this.revisionRecords[drugId].expireDates[index]) return;
        if (!this.revisionRecords[drugId].expireDates[index].date) return;
        if (!+this.revisionRecords[drugId].revisionQty) return;
        this.revisionRecords[drugId].expireDates[index].selected = !this.revisionRecords[drugId].expireDates[index].selected;
      }
      const {data} = await api.post('/stores/updateRevision', {
        action: 'expireDateSelect',
        revision_id: this.currentRevision.id,
        drug_id: drugId,
        expireDate: this.revisionRecords[drugId].expireDates.filter((e) => e.selected)
      });
      if (data.success) {
        if (!silent) toastr['success']('обновлено', 'Успешно');
      } else {
        toastr['warning'](data.message ?? 'нет ответа', 'Ошибка');
      }
    },
    getSortedRates(records) {
      const allRecords = records.map((r) => {
        r.sortDate = moment(r.date, 'MM.YYYY').unix();
        return r;
      })
      return _.orderBy(allRecords, 'sortDate');
    },
    filterDrugs(sort = null) {
      if (sort) this.sortDirection = sort;
      this.filteredRecords = [];
      if (this.searchDrugText) {
        this.showFilled = false;
        const searchText = this.searchDrugText.toLowerCase();
        this.filteredRecords = this.storeRecords.filter((d) => (d.drug.en_title ?? '').toLowerCase().includes(searchText) || (d.drug.title ?? '').toLowerCase().includes(searchText))
      } else {
        this.filteredRecords = [...this.storeRecords];
      }
    },
    async updateRecord(drugId, action) {
      // console.log(drugId, action);
      if (action === 'expireDate') {
        let pass = true;
        this.revisionRecords[drugId].expireDates.forEach((e) => {
          if (!e.date) return;
          if (e.date.length !== 7) pass = false;
        })
        if (!pass) {
          toastr['warning']('срок годности введен не верно', 'Ошибка');
          return;
        }
      }
      if (action === 'qty') {
        this.revisionRecords[drugId].showExpDates = true;
        this.revisionRecords[drugId].updated_timestamp = moment().utc().unix();
      }
      this.getEmptyExpireDates();
      const {data} = await api.post('/stores/updateRevision', {
        action,
        revision_id: this.currentRevision.id,
        drug_id: drugId,
        drugData: this.revisionRecords[drugId]
      })
      if (data.success) {
        if (!+this.revisionRecords[drugId].revisionQty) {
          this.revisionRecords[drugId].expireDates.forEach((r, i) => {
            if (this.revisionRecords[drugId].expireDates[i]) {
              this.revisionRecords[drugId].expireDates[i].selected = false;
            }
          })
          if (this.revisionRecords[drugId].expireDates.length) {
            await this.toggleSelectedDate(drugId, null, true);
          }
        }
        if (action === 'qty') {
          if (!this.revisionRecords[drugId].extra_data) this.revisionRecords[drugId].extra_data = {expire_dates: []};
        }
        toastr['success']('обновлено', 'Успешно');
        this.getEmptyExpireDates();
      }
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/stores/lastActiveRevision/2');
      if (data.success) {
        this.revisionRecords = data.storeRecords.reduce((acc, r) => {
          acc[r.drug_id] = {
            qty: r.qty,
            showExpDates: false,
            drug: {id: r.drug.id, title: r.drug.title},
            revisionQty: "",
            // extra_data: {expire_dates: []},
            expireDates: [{date: "", selected: false}],
          }
          return acc;
        }, {})
        data.revision?.details.forEach((d) => {
          if (!this.revisionRecords[d.drug_id]) this.revisionRecords[d.drug_id] = {
            qty: 0,
            revisionQty: "",
            expireDates: [{date: "", selected: false}],
            updated_timestamp: moment(r.updated_at).unix()
          }
          this.revisionRecords[d.drug_id].extra_data = {expire_dates: [], ...d.extra_data};
          if (this.revisionRecords[d.drug_id].extra_data?.expire_dates) {
            this.revisionRecords[d.drug_id].extra_data.expire_dates = this.revisionRecords[d.drug_id].extra_data.expire_dates.reduce((acc, d) => {
              acc[d] = true;
              return acc;
            }, {})
          }
          this.revisionRecords[d.drug_id].revisionQty = d.actual_qty;
          if (+d.actual_qty) {
            this.revisionRecords[d.drug_id].showExpDates = true;
          }
          this.revisionRecords[d.drug_id].record_id = d.id;
          this.revisionRecords[d.drug_id].updated_at = d.updated_at;
        })
        data.expireDates.forEach((e) => {
          if (!this.revisionRecords[e.drug_id].expireDates[0].date) {
            this.revisionRecords[e.drug_id].expireDates[0] = {
              date: moment(e.expire_date).format('MM.YYYY'),
              id: e.id,
              selected: false
            }
          } else {
            this.revisionRecords[e.drug_id].expireDates.push({
              date: moment(e.expire_date).format('MM.YYYY'),
              id: e.id,
              selected: false
            })
          }
        })

        this.revisionRecords = Object.keys(this.revisionRecords).reduce((acc, id) => {
          acc[id] = {...this.revisionRecords[id]}
          acc[id].expireDates = this.getSortedRates(acc[id].expireDates);
          return acc;
        }, {});

        (data?.revision?.details ?? []).forEach((d) => {
          ((d.extra_data ?? {})?.selected_expire_dates ?? []).forEach((e) => {
            const index = (this.revisionRecords[d.drug_id].expireDates ?? []).findIndex((r) => r.id === e.id);
            if (index !== -1) {
              this.revisionRecords[d.drug_id].expireDates[index].selected = true;
            }
          })
        })

        this.currentRevision = {id: data.revision.id};
        this.drugsImages = data.drugsImages;
        this.storeRecords = _.orderBy(data.storeRecords, 'drug.title').map((r) => {
          return {
            ...r,
            updated_timestamp: this.revisionRecords[r.drug_id] ? moment(this.revisionRecords[r.drug_id].updated_at).unix() : null
          }
        });
        this.filteredRecords = [...this.storeRecords];
        setTimeout(() => {
          this.getEmptyExpireDates();
        }, 300);

      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
table.table td {
  padding: 3px;
}

.date_input {
  height: 36px;
}

table th, .table td, .table input {
  font-size: 0.8rem;
}
</style>
